{
  "HELP_CENTER": {
    "TITLE": "Center za pomoč",
    "NEW_PAGE": {
      "DESCRIPTION": "Ustvarite portale za samopostrežno pomoč za svoje stranke. Pomagajte jim hitro najti odgovore, brez čakanja. Poenostavite povpraševanja, povečajte učinkovitost agentov in izboljšajte podporo strankam.",
      "CREATE_PORTAL_BUTTON": "Ustvari portal"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Brez naslova"
    },
    "HEADER": {
      "FILTER": "Filtriraj po",
      "SORT": "Razvrsti po",
      "LOCALE": "Jezik",
      "SETTINGS_BUTTON": "Nastavitve",
      "NEW_BUTTON": "Nov članek",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Objavljeno",
        "DRAFT": "Draft",
        "ARCHIVED": "Arhivirano"
      },
      "TITLES": {
        "ALL_ARTICLES": "Vsi članki",
        "MINE": "Moji članki",
        "DRAFT": "Draft članki",
        "ARCHIVED": "Arhivirani članki"
      },
      "LOCALE_SELECT": {
        "TITLE": "Izberite jezik",
        "PLACEHOLDER": "Izberite jezik",
        "NO_RESULT": "Jezika ni bilo mogoče najti",
        "SEARCH_PLACEHOLDER": "Iskanje jezika"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Vsi članki",
      "PUBLISH_BUTTON": "Objavi",
      "MOVE_TO_ARCHIVE_BUTTON": "Premakni v arhiv",
      "PREVIEW": "Predogled",
      "ADD_TRANSLATION": "Dodaj prevod",
      "OPEN_SIDEBAR": "Odpri stransko vrstico",
      "CLOSE_SIDEBAR": "Zapri stransko vrstico",
      "SAVING": "Shranjevanje ...",
      "SAVED": "Shranjeno"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Naloži sliko",
        "UPLOADING": "Nalaganje...",
        "SUCCESS": "Slika je bila uspešno naložena",
        "ERROR": "Napaka pri nalaganju slike",
        "UN_AUTHORIZED_ERROR": "Nimate pooblastila za nalaganje slik",
        "ERROR_FILE_SIZE": "Velikost slike mora biti manjša od {size}MB",
        "ERROR_FILE_FORMAT": "Format slike mora biti jpg, jpeg ali png",
        "ERROR_FILE_DIMENSIONS": "Dimenzije slike morajo biti manjše od 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Vstavi sidro",
        "TITLE": "Vstavi sidro",
        "SUBMIT": "Vstavi",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Nastavitve članka",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategorija",
          "TITLE": "Izberite kategorijo",
          "PLACEHOLDER": "Izberite kategorijo",
          "NO_RESULT": "Kategorije ni bilo mogoče najti",
          "SEARCH_PLACEHOLDER": "Iskanje kategorije"
        },
        "AUTHOR": {
          "LABEL": "Avtor",
          "TITLE": "Izberite avtorja",
          "PLACEHOLDER": "Izberite avtorja",
          "NO_RESULT": "Avtorjev ni bilo mogoče najti",
          "SEARCH_PLACEHOLDER": "Iskanje avtorja"
        },
        "META_TITLE": {
          "LABEL": "Meta naslov",
          "PLACEHOLDER": "Dodajte meta naslov"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta opis",
          "PLACEHOLDER": "Dodajte meta opis za boljše rezultate SEO ..."
        },
        "META_TAGS": {
          "LABEL": "Meta oznake",
          "PLACEHOLDER": "Dodajte meta oznake, ločene z vejico ..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Arhiviraj članek",
        "DELETE": "Izbriši članek"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Nekategorizirano",
      "SEARCH_RESULTS": "Rezultati iskanja za {query}",
      "EMPTY_TEXT": "Poiščite članke, ki jih želite vstaviti v odgovore.",
      "SEARCH_LOADER": "Iskanje ...",
      "INSERT_ARTICLE": "Vstavi",
      "NO_RESULT": "Ni najdenih člankov",
      "COPY_LINK": "Kopiraj povezavo do članka v odložišče",
      "OPEN_LINK": "Odpri članek v novem zavihku",
      "PREVIEW_LINK": "Predogled članka"
    },
    "PORTAL": {
      "HEADER": "Portali",
      "DEFAULT": "Privzeto",
      "NEW_BUTTON": "Nov portal",
      "ACTIVE_BADGE": "aktivno",
      "CHOOSE_LOCALE_LABEL": "Izberite jezik",
      "LOADING_MESSAGE": "Nalaganje portalov ...",
      "ARTICLES_LABEL": "članki",
      "NO_PORTALS_MESSAGE": "Trenutno ni razpoložljivih portalov",
      "ADD_NEW_LOCALE": "Dodaj nov jezik",
      "POPOVER": {
        "TITLE": "Portali",
        "PORTAL_SETTINGS": "Nastavitve portala",
        "SUBTITLE": "Imate več portalov in lahko za vsak portal nastavite drugačne jezike.",
        "CANCEL_BUTTON_LABEL": "Prekliči",
        "CHOOSE_LOCALE_BUTTON": "Izberi jezik"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "člankov",
            "ADD": "Dodaj jezik",
            "VISIT": "Obišči spletno mesto",
            "SETTINGS": "Nastavitve",
            "DELETE": "Izbriši"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Konfiguracije portala",
            "ITEMS": {
              "NAME": "Ime",
              "DOMAIN": "Domena po meri",
              "SLUG": "Slug",
              "TITLE": "Naslov portala",
              "THEME": "Barva teme",
              "SUB_TEXT": "Podnaslov portala"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Razpoložljivi jeziki",
            "TABLE": {
              "NAME": "Ime jezika",
              "CODE": "Koda jezika",
              "ARTICLE_COUNT": "Št. člankov",
              "CATEGORIES": "Št. kategorij",
              "SWAP": "Zamenjaj",
              "DELETE": "Izbriši",
              "DEFAULT_LOCALE": "Privzeto"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Izbriši portal",
          "MESSAGE": "Ali ste prepričani, da želite izbrisati ta portal",
          "YES": "Da, izbriši portal",
          "NO": "Ne, obdrži portal",
          "API": {
            "DELETE_SUCCESS": "Portal je bil uspešno izbrisan",
            "DELETE_ERROR": "Napaka pri brisanju portala"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Uredi portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Osnovne informacije"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Prilagoditev portala"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategorije"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Jeziki"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategorije v",
          "NEW_CATEGORY": "Nova kategorija",
          "TABLE": {
            "NAME": "Ime",
            "DESCRIPTION": "Opis",
            "LOCALE": "Jezik",
            "ARTICLE_COUNT": "Št. člankov",
            "ACTION_BUTTON": {
              "EDIT": "Uredi kategorijo",
              "DELETE": "Izbriši kategorijo"
            },
            "EMPTY_TEXT": "Ni najdenih kategorij"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Posodobi osnovne nastavitve"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informacije centra za pomoč",
            "BODY": "Osnovne informacije o portalu"
          },
          "CUSTOMIZATION": {
            "TITLE": "Prilagoditev centra za pomoč",
            "BODY": "Prilagodite portal"
          },
          "FINISH": {
            "TITLE": "Čestitamo! 🎉",
            "BODY": "Vse je pripravljeno!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Nazaj",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Ustvari portal",
            "TITLE": "Informacije centra za pomoč",
            "CREATE_BASIC_SETTING_BUTTON": "Ustvari osnovne nastavitve portala"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Prilagoditev portala",
            "TITLE": "Prilagoditev centra za pomoč",
            "UPDATE_PORTAL_BUTTON": "Posodobi nastavitve portala"
          },
          "FINISH_PAGE": {
            "TITLE": "Čestitamo! 🎉 Vse je pripravljeno!",
            "MESSAGE": "Novo ustvarjeni portal si zdaj lahko ogledate na strani z vsemi portali.",
            "FINISH": "Pojdi na stran z vsemi portali"
          }
        },
        "LOGO": {
          "LABEL": "Logotip",
          "UPLOAD_BUTTON": "Naloži logotip",
          "HELP_TEXT": "Ta logotip bo prikazan v glavi portala.",
          "IMAGE_UPLOAD_SUCCESS": "Logotip je bil uspešno naložen",
          "IMAGE_UPLOAD_ERROR": "Logotip je bil uspešno izbrisan",
          "IMAGE_DELETE_ERROR": "Napaka pri brisanju logotipa"
        },
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Ime portala",
          "HELP_TEXT": "Ime bo interno uporabljeno v javno dostopnem portalu.",
          "ERROR": "Ime je obvezno"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug portala za URL-je",
          "ERROR": "Slug je obvezen"
        },
        "DOMAIN": {
          "LABEL": "Domena po meri",
          "PLACEHOLDER": "Domena portala po meri",
          "HELP_TEXT": "Dodajte samo, če želite za svoje portale uporabiti domeno po meri. Npr.: {exampleURL}",
          "ERROR": "Vnesite veljaven URL domene"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Povezava do domače strani",
          "PLACEHOLDER": "Povezava do domače strani portala",
          "HELP_TEXT": "Povezava, ki se uporablja za vrnitev s portala na domačo stran. Npr.: {exampleURL}",
          "ERROR": "Vnesite veljaven URL domače strani"
        },
        "THEME_COLOR": {
          "LABEL": "Barva teme portala",
          "HELP_TEXT": "Ta barva bo prikazana kot barva teme portala."
        },
        "PAGE_TITLE": {
          "LABEL": "Naslov strani",
          "PLACEHOLDER": "Naslov strani portala",
          "HELP_TEXT": "Naslov strani bo uporabljen v javno dostopnem portalu.",
          "ERROR": "Naslov strani je obvezen"
        },
        "HEADER_TEXT": {
          "LABEL": "Besedilo glave",
          "PLACEHOLDER": "Besedilo glave portala",
          "HELP_TEXT": "Besedilo glave portala bo uporabljeno v javno dostopnem portalu.",
          "ERROR": "Besedilo glave portala je obvezno"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal je bil uspešno ustvarjen.",
          "ERROR_MESSAGE_FOR_BASIC": "Portala ni bilo mogoče ustvariti. Poskusite znova.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal je bil uspešno posodobljen.",
          "ERROR_MESSAGE_FOR_UPDATE": "Portala ni bilo mogoče posodobiti. Poskusite znova."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Dodaj nov jezik",
        "SUB_TITLE": "S tem dodate nov jezik na seznam razpoložljivih prevodov.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Jezik",
          "PLACEHOLDER": "Izberite jezik",
          "ERROR": "Jezik je obvezen"
        },
        "BUTTONS": {
          "CREATE": "Ustvari jezik",
          "CANCEL": "Prekliči"
        },
        "API": {
          "SUCCESS_MESSAGE": "Jezik je bil uspešno dodan",
          "ERROR_MESSAGE": "Jezika ni bilo mogoče dodati. Poskusite znova."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Privzeti jezik je bil uspešno posodobljen",
          "ERROR_MESSAGE": "Privzetega jezika ni bilo mogoče posodobiti. Poskusite znova."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Jezik je bil uspešno odstranjen iz portala",
          "ERROR_MESSAGE": "Jezika ni bilo mogoče odstraniti iz portala. Poskusite znova."
        }
      }
    },
    "TABLE": {
      "404": "Iskanju ne ustreza noben članek 🔍",
      "LOADING_MESSAGE": "Nalaganje člankov ...",
      "NO_ARTICLES": "Trenutno ni razpoložljivih člankov",
      "HEADERS": {
        "TITLE": "Naslov",
        "CATEGORY": "Kategorija",
        "READ_COUNT": "Ogledi",
        "STATUS": "Stanje",
        "LAST_EDITED": "Nazadnje urejeno"
      },
      "COLUMNS": {
        "BY": "avtor",
        "AUTHOR_NOT_AVAILABLE": "Avtor ni na voljo"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Nalaganje članka ...",
      "TITLE_PLACEHOLDER": "Tukaj vnesite naslov članka",
      "CONTENT_PLACEHOLDER": "Tukaj napišite svoj članek",
      "API": {
        "ERROR": "Napaka pri shranjevanju članka"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Napaka pri objavljanju članka",
        "SUCCESS": "Članek je bil uspešno objavljen"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Napaka pri arhiviranju članka",
        "SUCCESS": "Članek je bil uspešno arhiviran"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Napaka pri premikanju članka v stanje Draft",
        "SUCCESS": "Članek je bil uspešno premaknjen v stanje Draft"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Potrdi brisanje",
          "MESSAGE": "Ali ste prepričani, da želite izbrisati ta članek?",
          "YES": "Da, izbriši",
          "NO": "Ne, obdrži"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Članek je bil uspešno izbrisan",
        "ERROR_MESSAGE": "Napaka pri brisanju članka"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Najprej dodajte naslov in vsebino članka, šele nato lahko posodobite nastavitve"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Iskanje člankov"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Ustvari kategorijo",
        "SUB_TITLE": "Kategorija bo uporabljena v javno dostopnem portalu za razvrščanje člankov.",
        "PORTAL": "Portal",
        "LOCALE": "Jezik",
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Ime kategorije",
          "HELP_TEXT": "Ime in ikona kategorije bosta uporabljena v javno dostopnem portalu za razvrščanje člankov.",
          "ERROR": "Ime je obvezno"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategorije za URL-je",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug je obvezen"
        },
        "DESCRIPTION": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Na kratko opišite kategorijo.",
          "ERROR": "Opis je obvezen"
        },
        "BUTTONS": {
          "CREATE": "Ustvari kategorijo",
          "CANCEL": "Prekliči"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorija je bila uspešno ustvarjena",
          "ERROR_MESSAGE": "Kategorije ni bilo mogoče ustvariti"
        }
      },
      "EDIT": {
        "TITLE": "Uredi kategorijo",
        "SUB_TITLE": "Urejanje kategorije bo posodobilo kategorijo v javno dostopnem portalu.",
        "PORTAL": "Portal",
        "LOCALE": "Jezik",
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Ime kategorije",
          "HELP_TEXT": "Ime in ikona kategorije bosta uporabljena v javno dostopnem portalu za razvrščanje člankov.",
          "ERROR": "Ime je obvezno"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategorije za URL-je",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug je obvezen"
        },
        "DESCRIPTION": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Na kratko opišite kategorijo.",
          "ERROR": "Opis je obvezen"
        },
        "BUTTONS": {
          "CREATE": "Posodobi kategorijo",
          "CANCEL": "Prekliči"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorija je bila uspešno posodobljena",
          "ERROR_MESSAGE": "Kategorije ni bilo mogoče posodobiti"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategorija je bila uspešno izbrisana",
          "ERROR_MESSAGE": "Kategorije ni bilo mogoče izbrisati"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Iskanje člankov",
      "PLACEHOLDER": "Iskanje člankov",
      "NO_RESULT": "Ni najdenih člankov",
      "SEARCHING": "Iskanje ...",
      "SEARCH_BUTTON": "Išči",
      "INSERT_ARTICLE": "Vstavi povezavo",
      "IFRAME_ERROR": "URL je prazen ali neveljaven. Vsebine ni mogoče prikazati.",
      "OPEN_ARTICLE_SEARCH": "Vstavi članek iz centra za pomoč",
      "SUCCESS_ARTICLE_INSERTED": "Članek je bil uspešno vstavljen",
      "PREVIEW_LINK": "Predogled članka",
      "CANCEL": "Zapri",
      "BACK": "Nazaj",
      "BACK_RESULTS": "Nazaj na rezultate"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Center za pomoč",
      "DESCRIPTION": "Ustvarite uporabniku prijazne samopostrežne portale. Pomagajte svojim uporabnikom do dostopa do člankov in podpore 24/7. Nadgradite svojo naročnino, da omogočite to funkcijo.",
      "SELF_HOSTED_DESCRIPTION": "Ustvarite uporabniku prijazne samopostrežne portale. Pomagajte svojim uporabnikom do dostopa do člankov in podpore 24/7. Za omogočanje te funkcije se obrnite na skrbnika.",
      "BUTTON": {
        "LEARN_MORE": "Preberi več",
        "UPGRADE": "Nadgradi"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Več portalov",
          "DESCRIPTION": "Ustvarite več portalov centra za pomoč za različne izdelke znotraj istega računa."
        },
        "LOCALES": {
          "TITLE": "Polna podpora za jezike",
          "DESCRIPTION": "Prilagodite portal svojemu jeziku. Podpiramo vse jezike in omogočamo prevode za vsak članek."
        },
        "SEO": {
          "TITLE": "Zasnova, prijazna do SEO",
          "DESCRIPTION": "Prilagodite svoje meta oznake za boljšo vidnost na iskalnikih z našimi stranmi, prijaznimi do SEO."
        },
        "API": {
          "TITLE": "Polna podpora za API",
          "DESCRIPTION": "Uporabite portal kot brezglavi CMS z zunanjimi ogrodji za razvoj vmesnikov prek naših API-jev."
        }
      }
    },
    "LOADING": "Nalaganje ...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} ogled | {count} ogledov",
          "DROPDOWN_MENU": {
            "PUBLISH": "Objavi",
            "DRAFT": "Draft",
            "ARCHIVE": "Arhiviraj",
            "DELETE": "Izbriši"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Objavljeno",
            "ARCHIVED": "Arhivirano"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Nekategorizirano"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Vsi članki",
          "MINE": "Moji",
          "DRAFT": "Draft",
          "PUBLISHED": "Objavljeno",
          "ARCHIVED": "Arhivirano"
        },
        "CATEGORY": {
          "ALL": "Vse kategorije"
        },
        "LOCALE": {
          "ALL": "Vsi jeziki"
        },
        "NEW_ARTICLE": "Nov članek"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Napišite članek",
          "SUBTITLE": "Napišite bogat članek, začnimo!",
          "BUTTON_LABEL": "Nov članek"
        },
        "MINE": {
          "TITLE": "Tukaj še niste napisali nobenega članka",
          "SUBTITLE": "Vsi članki, ki ste jih napisali, se prikažejo tukaj za hiter dostop."
        },
        "DRAFT": {
          "TITLE": "V razdelku Draft ni člankov",
          "SUBTITLE": "Članki v stanju Draft se bodo prikazali tukaj"
        },
        "PUBLISHED": {
          "TITLE": "Ni objavljenih člankov",
          "SUBTITLE": "Objavljeni članki se bodo prikazali tukaj"
        },
        "ARCHIVED": {
          "TITLE": "V arhivu ni člankov",
          "SUBTITLE": "Arhivirani članki se ne prikazujejo na portalu; z njimi lahko označite zastarele ali opuščene strani"
        },
        "CATEGORY": {
          "TITLE": "V tej kategoriji ni člankov",
          "SUBTITLE": "Članki v tej kategoriji se bodo prikazali tukaj"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nova kategorija",
        "EDIT_CATEGORY": "Uredi kategorijo",
        "CATEGORIES_COUNT": "{n} kategorija | {n} kategorij",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategorije ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} člankov) | {categoryName} ({categoryCount} članek)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Ni najdenih kategorij",
        "SUBTITLE": "Kategorije se bodo prikazale tukaj. Kategorijo lahko dodate s klikom na gumb 'Nova kategorija'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} članek | {count} člankov",
        "EXPAND": "Prikaži podkategorije",
        "COLLAPSE": "Skrij podkategorije",
        "MENU": {
          "NEW_ARTICLE": "Nov članek",
          "ADD_SUBCATEGORY": "Dodaj podkategorijo",
          "EDIT": "Uredi",
          "DELETE": "Izbriši"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija je bila uspešno ustvarjena",
            "ERROR_MESSAGE": "Kategorije ni bilo mogoče ustvariti"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija je bila uspešno posodobljena",
            "ERROR_MESSAGE": "Kategorije ni bilo mogoče posodobiti"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija je bila uspešno izbrisana",
            "ERROR_MESSAGE": "Kategorije ni bilo mogoče izbrisati"
          },
          "CONFIRM": {
            "TITLE": "Izbriši kategorijo",
            "DESCRIPTION": "Ali ste prepričani, da želite izbrisati to kategorijo? Njeni članki bodo postali nekategorizirani.",
            "DESCRIPTION_WITH_CHILDREN": "Ali ste prepričani, da želite izbrisati to kategorijo? Njeni članki bodo postali nekategorizirani, njena {count} podkategorija pa bo premaknjena na najvišjo raven. | Ali ste prepričani, da želite izbrisati to kategorijo? Njeni članki bodo postali nekategorizirani, njenih {count} podkategorij pa bo premaknjenih na najvišjo raven.",
            "CONFIRM": "Izbriši"
          }
        },
        "HEADER": {
          "CREATE": "Ustvari kategorijo",
          "EDIT": "Uredi kategorijo",
          "DESCRIPTION": "Urejanje kategorije bo posodobilo kategorijo v javno dostopnem portalu.",
          "PORTAL": "Portal",
          "LOCALE": "Jezik"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Ime",
            "PLACEHOLDER": "Ime kategorije",
            "ERROR": "Ime je obvezno"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug kategorije za URL-je",
            "ERROR": "Slug je obvezen",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Opis",
            "PLACEHOLDER": "Na kratko opišite kategorijo.",
            "ERROR": "Opis je obvezen"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Nadrejena kategorija",
            "PLACEHOLDER": "Izberite nadrejeno kategorijo",
            "NONE": "Brez (najvišja raven)"
          }
        },
        "BUTTONS": {
          "CREATE": "Ustvari",
          "EDIT": "Posodobi",
          "CANCEL": "Prekliči"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Ni razpoložljivih jezikov | {n} jezik | {n} jezikov",
      "NEW_LOCALE_BUTTON_TEXT": "Nov jezik",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} članek | {count} člankov",
        "CATEGORIES_COUNT": "{count} kategorija | {count} kategorij",
        "DEFAULT": "Privzeto",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Nastavi kot privzeto",
          "DELETE": "Izbriši"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Dodaj nov jezik",
        "DESCRIPTION": "Izberite jezik, v katerem bo ta članek napisan. Dodan bo na vaš seznam prevodov, kasneje pa jih lahko dodate še več.",
        "COMBOBOX": {
          "PLACEHOLDER": "Izberite jezik ..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Jezik je bil uspešno dodan",
          "ERROR_MESSAGE": "Jezika ni bilo mogoče dodati. Poskusite znova."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Shranjevanje ...",
          "SAVED": "Shranjeno"
        },
        "PREVIEW": "Predogled",
        "PUBLISH": "Objavi",
        "DRAFT": "Draft",
        "ARCHIVE": "Arhiviraj",
        "BACK_TO_ARTICLES": "Nazaj na članke"
      },
      "DRAFT": {
        "PENDING_LABEL": "Neobjavljene spremembe",
        "PROMOTE": "Objavi spremembe",
        "DISCARD": "Zavrzi spremembe",
        "PROMOTE_SUCCESS": "Spremembe osnutka so objavljene v aktivnem članku",
        "PROMOTE_ERROR": "Sprememb osnutka ni bilo mogoče objaviti",
        "DISCARD_SUCCESS": "Spremembe osnutka so bile zavržene",
        "DISCARD_ERROR": "Sprememb osnutka ni bilo mogoče zavreči"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Zgodovina različic",
        "TITLE": "Zgodovina različic",
        "BACK": "Nazaj na članek",
        "LOADING": "Nalaganje različic ...",
        "EMPTY": "Še ni različic. Spremembe tega članka se bodo prikazale tukaj.",
        "EMPTY_CONTENT": "Ta različica nima vsebine.",
        "CURRENT_BADGE": "Trenutna",
        "RESTORED_BADGE": "Obnovljena",
        "AUTOMATED_USER": "Samodejna posodobitev",
        "RESTORE": "Obnovi to različico",
        "RESTORE_DIALOG": {
          "TITLE": "Obnoviti to različico?",
          "DESCRIPTION": "Članek se bo vrnil na besedilo te različice. Nič ne bo izgubljeno — trenutno besedilo ostane v zgodovini, objavljeni članek pa bo še naprej prikazoval trenutno različico, dokler spremembe ne objavite.",
          "CONFIRM": "Obnovi"
        },
        "RESTORE_SUCCESS": "Različica obnovljena",
        "RESTORE_ERROR": "Te različice ni bilo mogoče obnoviti",
        "FETCH_ERROR": "Zgodovine različic ni bilo mogoče naložiti"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Več lastnosti",
        "TRANSLATE": "Prevedi",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Nekategorizirano",
        "EDITOR_PLACEHOLDER": "Napišite nekaj ...",
        "HTML_EMBED": {
          "TITLE": "Vstavi HTML po meri",
          "DESCRIPTION": "Prilepite surovo kodo HTML, na primer iframe, vdelavo ali odlomek pripomočka. V objavljenem članku bo prikazana takšna, kot je.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Vstavi"
        },
        "PRIMARY_CATEGORY": "Primarna kategorija"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Lastnosti članka",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Meta opis",
        "META_DESCRIPTION_PLACEHOLDER": "Dodaj meta opis",
        "META_TITLE": "Meta naslov",
        "META_TITLE_PLACEHOLDER": "Dodaj meta naslov",
        "META_TAGS": "Meta oznake",
        "META_TAGS_PLACEHOLDER": "Dodaj meta oznake",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Jezikovne različice",
        "LANGUAGE_MUTATIONS_EMPTY": "Še ni povezanih člankov",
        "ADD_MUTATION": "Dodaj",
        "REMOVE_MUTATION": "Odstrani"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Poveži jezikovne različice",
        "SEARCH_PLACEHOLDER": "Iskanje člankov po naslovu",
        "EMPTY": "Ni ujemajočih se člankov",
        "CANCEL": "Prekliči",
        "ADD_SELECTED": "Dodaj izbrane",
        "SUCCESS": "Različice posodobljene",
        "ERROR": "Posodobitev različic ni uspela"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Prevedi članek",
        "DESCRIPTION": "Izberite jezike, v katere želite prevesti ta članek. Jeziki, ki so že prevedeni, bodo ponovno prevedeni v Draft za pregled.",
        "EMPTY": "Na voljo ni nobenega drugega jezika.",
        "CONNECTED_BADGE": "Prevedeno",
        "CANCEL": "Prekliči",
        "TRANSLATE": "Prevedi",
        "SUCCESS": "Prevajanje se bo kmalu začelo. Prevedeni članki se bodo kmalu prikazali kot jezikovne različice.",
        "ERROR": "Prevajanja ni bilo mogoče začeti"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Napaka pri shranjevanju članka"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Nov portal",
      "PORTALS": "Portali",
      "CREATE_PORTAL": "Ustvarite in upravljajte več portalov",
      "ARTICLES": "članki",
      "DOMAIN": "domena",
      "PORTAL_NAME": "Ime portala"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Ustvari nov portal",
      "DESCRIPTION": "Poimenujte svoj portal in ustvarite uporabniku prijazen URL slug. Oboje lahko kasneje spremenite v nastavitvah.",
      "CONFIRM_BUTTON_LABEL": "Ustvari",
      "NAME": {
        "LABEL": "Ime",
        "PLACEHOLDER": "Uporabniški priročnik",
        "MESSAGE": "Izberite ime za svoj portal.",
        "ERROR": "Ime je obvezno"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug je obvezen",
        "FORMAT_ERROR": "Uporabite samo črke, številke in vezaje, na primer: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logotip",
          "IMAGE_UPLOAD_ERROR": "Slike ni bilo mogoče naložiti! Poskusite znova",
          "IMAGE_UPLOAD_SUCCESS": "Slika je bila uspešno dodana. Kliknite Shrani spremembe, da shranite logotip",
          "IMAGE_DELETE_SUCCESS": "Logotip je bil uspešno izbrisan",
          "IMAGE_DELETE_ERROR": "Logotipa ni bilo mogoče izbrisati",
          "IMAGE_UPLOAD_SIZE_ERROR": "Velikost slike mora biti manjša od {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Ime portala",
          "ERROR": "Ime je obvezno"
        },
        "HEADER_TEXT": {
          "LABEL": "Besedilo glave",
          "PLACEHOLDER": "Besedilo glave portala"
        },
        "PAGE_TITLE": {
          "LABEL": "Naslov strani",
          "PLACEHOLDER": "Naslov strani portala"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Povezava do domače strani",
          "PLACEHOLDER": "Povezava do domače strani portala",
          "ERROR": "Neveljaven URL. Povezava do domače strani se mora začeti z 'http://' ali 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug portala"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Klepetalni pripomoček v živo",
          "PLACEHOLDER": "Izberite klepetalni pripomoček v živo",
          "HELP_TEXT": "Izberite klepetalni pripomoček v živo, ki se bo prikazal v vašem centru za pomoč"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Javno dostopno",
          "HELP_TEXT": "Naredite portal dostopen vsem s povezavo.",
          "OPTIONS": {
            "PUBLIC": "Da",
            "PRIVATE": "Ne"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Cilj povezave",
          "HELP_TEXT": "Izberite, ali se povezave v člankih odpirajo v trenutnem oknu ali v novem.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Trenutno okno",
            "NEW_WINDOW": "Novo okno"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Privzeta velikost slike",
          "HELP_TEXT": "Velikost, ki se uporabi za vsako sliko, ki jo vstavite v članek. Izberite Original, da slike vstavite v njihovi lastni velikosti, sicer pa velikost izberete za vsako sliko posebej."
        },
        "BRAND_COLOR": {
          "LABEL": "Barva blagovne znamke"
        },
        "CUSTOM_HTML": {
          "LABEL": "Prilagojen HTML",
          "PLACEHOLDER": "<!-- Sem prilepite kodo za analitiko ali sledenje -->",
          "HELP_TEXT": "Vstavljeno na začetku oznake <body> na vsaki strani centra za pomoč. Uporabite jo za Google Analytics, Google Tag Manager ali katero koli drugo kodo za sledenje. Koda se prikaže natanko tako, kot je vnesena, in ni preverjena."
        },
        "SAVE_CHANGES": "Shrani spremembe"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Domena po meri",
          "LABEL": "Domena po meri:",
          "DESCRIPTION": "Svoj portal lahko gostite na domeni po meri. Če je na primer vaše spletno mesto vasa-domena.com in želite, da je vaš portal na voljo na docs.vasa-domena.com, to preprosto vnesite v to polje.",
          "PLACEHOLDER": "Domena portala po meri",
          "EDIT_BUTTON": "Uredi domeno po meri",
          "ADD_BUTTON": "Dodaj domeno po meri",
          "DIALOG": {
            "ADD_HEADER": "Dodaj domeno po meri",
            "EDIT_HEADER": "Uredi domeno po meri",
            "ADD_CONFIRM_BUTTON_LABEL": "Dodaj domeno",
            "EDIT_CONFIRM_BUTTON_LABEL": "Posodobi domeno",
            "LABEL": "Domena po meri",
            "PLACEHOLDER": "Domena portala po meri",
            "ERROR": "Domena po meri je obvezna"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Konfiguracija DNS",
            "DESCRIPTION": "Prijavite se v račun pri svojem ponudniku DNS in dodajte spodnji zapis CNAME za svojo poddomeno.",
            "HELP_TEXT": "Ko je to opravljeno, se lahko obrnete na našo podporo in zaprosite za samodejno ustvarjeno potrdilo SSL.",
            "CONFIRM_BUTTON_LABEL": "Razumem!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Izbriši {portalName}",
          "HEADER": "Izbriši portal",
          "DESCRIPTION": "Trajno izbrišite ta portal. Tega dejanja ni mogoče razveljaviti",
          "DIALOG": {
            "HEADER": "Ali ste prepričani, da želite izbrisati {portalName}?",
            "DESCRIPTION": "To je trajno dejanje, ki ga ni mogoče razveljaviti.",
            "CONFIRM_BUTTON_LABEL": "Izbriši"
          }
        },
        "EDIT_CONFIGURATION": "Uredi konfiguracijo"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal je bil uspešno ustvarjen",
          "ERROR_MESSAGE": "Portala ni bilo mogoče ustvariti"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal je bil uspešno posodobljen",
          "ERROR_MESSAGE": "Portala ni bilo mogoče posodobiti"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Priloge",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Dodaj datoteko",
      "DROP_HERE": "Povlecite in spustite datoteke sem",
      "COPY_LINK": "Kopiraj povezavo",
      "LINK_COPIED": "Povezava kopirana v odložišče",
      "COPY_FAILED": "Kopiranje povezave ni uspelo",
      "DELETE": "Izbriši",
      "CANCEL": "Prekliči",
      "QUEUED": "V čakalni vrsti",
      "UPLOADING": "Nalaganje",
      "UPLOAD_FAILED": "Nalaganje datoteke ni uspelo",
      "FILE_TOO_LARGE": "Datoteka presega omejitev velikosti 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Slovar prevodov",
        "DESCRIPTION": "Izrazi, opredeljeni tukaj, so dodani k pozivu za AI prevajanje, tako da so vedno prevedeni enako. Ključni izraz je zapisan v {locale}."
      },
      "NEW_TERM": "Nov izraz",
      "EMPTY_STATE": {
        "TITLE": "Še ni izrazov v slovarju",
        "SUBTITLE": "Dodajte izraz in njegov prevod za vsak jezik. Ko je članek preveden, se ti izrazi upoštevajo, da ostane besedišče vašega izdelka dosledno."
      },
      "LIST": {
        "TERM": "Izraz",
        "TRANSLATIONS": "Prevodi",
        "ACTIONS": "Dejanja"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Dodaj izraz",
          "EDIT": "Uredi izraz",
          "DESCRIPTION": "Spodnji izraz se upošteva pri AI prevajanju člankov v vašem centru za pomoč.",
          "PORTAL": "Portal",
          "PRIMARY_LANGUAGE": "Primarni jezik"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Izraz ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Izraz je obvezen"
          },
          "DESCRIPTION": {
            "LABEL": "Kontekst / opombe (neobvezno)",
            "PLACEHOLDER": "Kdaj in kako se ta izraz uporablja, da prevajalcu pomaga razjasniti pomen."
          },
          "TRANSLATIONS": "Prevodi",
          "TRANSLATION_PLACEHOLDER": "Pustite prazno, da lahko AI prevede prosto",
          "AUTO_TRANSLATE": {
            "BUTTON": "Samodejno prevedi vse",
            "CONFIRM": "Prevesti v {count} jezikov z AI?",
            "CONFIRM_BUTTON": "Prevedi",
            "CANCEL": "Prekliči",
            "SUCCESS": "Prevodi so ustvarjeni — preglejte jih in shranite",
            "ERROR": "Samodejnega prevajanja ni bilo mogoče izvesti, poskusite znova"
          }
        },
        "BUTTONS": {
          "CREATE": "Dodaj izraz",
          "EDIT": "Shrani",
          "CANCEL": "Prekliči"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Izraz je bil uspešno dodan",
            "ERROR_MESSAGE": "Izraza ni bilo mogoče dodati. Poskusite znova"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Izraz je bil uspešno posodobljen",
            "ERROR_MESSAGE": "Izraza ni bilo mogoče posodobiti. Poskusite znova"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Izbriši izraz",
          "DESCRIPTION": "Ali ste prepričani, da želite izbrisati ta izraz? Med prevajanjem ne bo več upoštevan.",
          "CONFIRM": "Izbriši"
        },
        "API": {
          "SUCCESS_MESSAGE": "Izraz je bil uspešno izbrisan",
          "ERROR_MESSAGE": "Izraza ni bilo mogoče izbrisati. Poskusite znova"
        }
      }
    }
  }
}
